import React from 'react';
import { observer } from 'mobx-react-lite';
import { cardsStore } from '../../store/cardsStore';
import { CARDS_TYPE, TABLE_CARDS } from '../../enums/cardTypes';

export const DealerCards = observer(() => {
  const { dealerCards, selectedCardType } = cardsStore;

  return (
    <div className='bet-on-poker-dealers-cards'>
      {TABLE_CARDS.map((item, index) => (
        <div
          key={item}
          className={`bet-on-poker-dealers-card-holder ${
            dealerCards[index]?.isWin ? 'active' : ''
          }`}
        >
          {Number.isInteger(dealerCards[index]?.card) && (
            <div
              className={`bet-on-poker-dealers-card ${selectedCardType} ${
                CARDS_TYPE[dealerCards[index]?.card]
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
});
